// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog_newpageContent__MW9IH {
    display: flex;
    justify-content: space-between;
    margin-top: 0;
    /* min-height: calc(100vh - 67px); */
    min-height: 100vh;
}

.blog_newpageRight__uoGBG {
    border-left: 1px solid #e6e6e6;
    margin-top: 0;
    max-height: calc(100vh - 67px);
    /* min-height: 100vh; */
    padding: 0;
    overflow-y: auto;
    position: relative;
    width: 410px;
}

.blog_newpageLeft__M3k\\+b {
    max-height: calc(100dvh - 100px);
    overflow-y: auto;
    /* margin-right: 36px; */
    padding-right: 40px;
    padding-left: 40px;
    width: calc(100% - 410px);
    padding-top: 30px;
}

.blog_buttonsDesktop__Q3IKR {
    border-bottom: 1px solid #e6e6e6;
    padding: 20px 30px;
    display: block;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
}

.blog_buttonsMobile__uhFom {
    border-bottom: 1px solid #e6e6e6;
    padding: 20px 30px;
    display: none;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
}

.blog_newpageRightButtons__Zee1P {
    display: inline-flex;
    position: relative;
    height: 44px;
}

.blog_newpageRightButtons__Zee1P button {
    font-family: 'CyGrotesk-KeyRegular';
}

.blog_newpageRightButtons__Zee1P button:first-child {
    border-radius: 6px;
}

.blog_newpageRightButtons__Zee1P button:first-child {
    border-radius: 4px;
    background: #0a0a0a;
}

.blog_newpageRightButtons__Zee1P button:first-child {
    /* background: #0a0a0a; */
    margin-right: 8px;
    /* min-width: 69px; */
    min-height: 42px;
    position: relative;
    justify-content: center;
    border-radius: 6px !important;
}

.blog_newpageRightButtons__Zee1P .blog_publishButton__0jA7O {
    width: 97.3px;
}

.blog_newpageRightButtons__Zee1P button {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    display: flex;
    gap: 8px;
    /* border-radius: 6px; */
    align-items: center;
    padding: 10px;
    /* border: none; */
    /* color: #fff; */
    cursor: pointer;
}

.blog_primaryButton__3JSm\\+ {
    box-shadow: 0 1px 3px #0000001a;
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
}

.blog_newpageRightButtons__Zee1P button:first-child p {
    font-weight: 500;
    margin: 0;
}

.blog_newpageRightButtons__Zee1P button:nth-child(2) {
    margin-right: 8px;
}

.blog_newpageRightButtons__Zee1P .blog_draftButton__vfQlb {
    width: 120px;
}

.blog_secondaryButton__rgdOV {
    background-color: #fff;
    color: #344054;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
}

.blog_updatePagebtn__m3n-I {
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
    box-shadow: 0 1px 3px #0000001a;
}

.blog_updateDraftButton__PKfEn {
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
    box-shadow: 0 1px 3px #0000001a;
}

.blog_newpageMoreButtons__Sf2bG {
    background-color: #fff;
    color: #344054;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
    width: 44px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.blog_actionDots__z-DHv {
    width: 16px;
    height: 16px;
}

.blog_buttonsMobile__uhFom .blog_publishedButtonsList__TAdQ- {
    top: -90px;
}

.blog_publishedButtonsList__TAdQ- {
    position: absolute;
    top: 50px;
    right: 0;
    background: #fff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    z-index: 10;
    min-width: 150px;
}

.blog_publishedButtonsList__TAdQ- ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.blog_publishedButtonsList__TAdQ- li {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #344054;
}

.blog_publishedButtonsList__TAdQ- li:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.blog_publishedButtonsList__TAdQ- li:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

.blog_publishedButtonsList__TAdQ- li:hover {
    background-color: #f9fafb;
}

.blog_publishStatus__JeUib {
    margin-top: 10px;
    font-size: 14px;
    color: #344054;
    margin-bottom: 0;
}

.blog_publishButton__0jA7O {
    width: 97.3px;
}

.blog_updatePagebtn__m3n-I {
    width: 74.83px;
}

.blog_updateDraftButton__PKfEn {
    width: 116.92px;
}

.blog_draftButton__vfQlb {
    width: 120px;
}

.blog_ringLoader__TPb8V {
    width: 20px;
    height: 20px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #000;
    border-radius: 50%;
    animation: blog_spin__uANIX 1s linear infinite;
}

@keyframes blog_spin__uANIX {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.blog_newpageRight__uoGBG>.blog_newPageRightRow__YAE7v {
    border-bottom: 1px solid #e6e6e6;
    border-top: 0;
    overflow: hidden;
    padding: 20px 30px;
}

.blog_newPageRightFullUrl__EnNv6,
.blog_newPageRightTitle__xRfwD {
    color: #344054;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
}

.blog_iconDropWrap__i4y0w {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    margin: 0;
}

.blog_iconDropWrap__i4y0w span {
    font-weight: 500;
    margin-right: 3px;
    width: calc(100% - 15px);
    display: block;
}

.blog_newPageRight__9f\\+x0:has(.blog_expanded__Y6\\+vO) .blog_dropdownIcon__SAvRh,
.blog_newPageRightRow__YAE7v:has(.blog_expanded__Y6\\+vO) .blog_dropdownIcon__SAvRh {
    transform: rotate(-180deg);
}

.blog_dropdownIcon__SAvRh {
    transition: all 0.2s linear;
    width: 12px;
}

.blog_expanded__Y6\\+vO {
    max-height: 1000px;
    transition: max-height 0.8s ease-in-out 0s;
}

.blog_collapse__Ln0XM {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.6s ease-in-out 0s;
}

.blog_urlInput__gFrQv {
    display: block;
    width: 100%;
}

.blog_adressInputBlock__gjp-G {
    position: relative;
}

.blog_adressInputBlock__gjp-G .blog_adressLink__xaatB {
    top: 24px;
}

.blog_adressLink__xaatB,
.blog_publication-Link__IXScO .blog_adressInputBlock__gjp-G .blog_url-icon__0KuvW {
    left: 14px;
    position: absolute;
    top: 1.48rem;
    width: 17px;
    height: 17px;
}

.blog_adressInputBlock__gjp-G.blog_urlInput__gFrQv>input {
    padding-left: 40px;
}

.blog_adressInputBlock__gjp-G input,
.blog_textExpert__qf6oP {
    padding: 8px 12px;
    gap: 8px;
    height: 45px;
    width: 100%;
    background: #ffffff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    outline: none;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 40px;
    font-size: 14px;
}

.blog_textExpert__qf6oP {
    resize: vertical;
    overflow-x: hidden;
    min-height: calc(1.2em * 5);
    padding: 8px 12px;
}

.blog_list-search__Hu3Gn p {
    color: #344054;
    font-size: 14px;
    line-height: 20px;
}

.blog_newpageRight__uoGBG>.blog_desktopFeatures__ncwvY {
    border-bottom: 1px solid #eaecf0;
}

.blog_newpageRight__uoGBG>.blog_desktopFeatures__ncwvY:has(.blog_expanded__Y6\\+vO) {
    border-color: transparent;
}

.blog_newpageRight__uoGBG>.blog_newPageRight__9f\\+x0 {
    padding: 20px 30px;
}

.blog_newPageRightRow__YAE7v.blog_imageUploadBox__Bo4q3 {
    margin-top: 10px;
    height: 200px;
    position: relative;
    border: 1px solid black;
    border-radius: 6px;
}

.blog_newpageImageUpload__Lm4Ey {
    background: #fff;
    border: 1px solid #eaecf0;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
    min-height: 100%;
    max-width: 384px;
    position: relative;
    z-index: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.blog_fileUploadCover_Img__1LyIj {
    margin: 0 auto;
    display: block;
}

.blog_fileUploadBox__lA1Xc .blog_fileUploadCover_Img__1LyIj {
    margin: 0 auto;
    background: #f2f4f7;
    border: 6px solid #f9fafb;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    padding: 5px !important;
    margin-bottom: 5px;
}

.blog_newpageImageUpload__Lm4Ey .blog_featureImgMiddleContent__kxJT3,
.blog_newpageImageUpload__Lm4Ey div .blog_newpage_CoverImg__VCw63,
.blog_newpageImageUpload__Lm4Ey .blog_featureImgMiddleContent__kxJT3,
.blog_newpageImageUpload__Lm4Ey div .blog_newpage_CoverImg__VCw63,
.blog_newpageImageUpload__Lm4Ey .blog_featureImgMiddleContent__kxJT3,
.blog_newpageImageUpload__Lm4Ey div .blog_newpage_CoverImg__VCw63 {
    width: 100%;
    height: 100%;
    min-height: 100%;
    max-width: 100%;
}

.blog_newPageImageUploadText__qhqPn {
    font-weight: 400;
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    color: #475467;
    -webkit-user-select: none;
            user-select: none;
    text-align: center;
    padding-top: 10px;
}

.blog_newPageImageUploadText__qhqPn span {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #1c1c1c;
}

.blog_contentDrop__TYJ6j>div.blog_scheduleCheckbox__ZUIrU {
    margin-top: 9px;
    position: relative;
}

.blog_listSearch__PbpPk label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
}

.blog_listSearch__PbpPk input[type="checkbox"] {
    font-size: 0;
    width: 18px;
    height: 18px;
    border: 1px solid transparent;
    -o-appearance: none;
    appearance: none;
    position: relative;
    padding: 0 0 0 0;
    margin: 0;
    margin-right: 9px !important;
    box-shadow: none;
}

.blog_listSearch__PbpPk input[type="checkbox"]:before {
    position: absolute;
    left: 0;
    top: -1px;
    margin-right: 0;
}

.blog_scheduleCheckbox__ZUIrU p {
    text-transform: unset;
}

.blog_listSearch__PbpPk p {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
}

.blog_verticleDots__i4eyi {
    position: relative;
    left: 0;
}

.blog_pageListHeight__UtDrO {
    overflow-y: hidden;
}

.blog_pageDatatableList__Vof70 {
    padding: 30px 30px 0;
}

.blog_pageHeader__wShOA {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.blog_pageHeader__wShOA .blog_pageHeading__cPy\\+H {
    font-size: 20px;
    font-weight: 600;
}

.blog_pageHeader__wShOA {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.blog_pageHeader__wShOA .blog_leftSide__4ASAl {
    display: flex;
    gap: 20px;
}

.blog_searchBar__qGGZa {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px 12px;
    gap: 8px;
    min-width: 250px;
    height: 40px;
}

.blog_searchBar__qGGZa img {
    width: 16px;
    height: 16px;
}

.blog_searchBar__qGGZa input {
    border: none;
    background: transparent;
    outline: none;
    flex: 1 1;
    font-size: 14px;
    color: #333;
}

.blog_searchBar__qGGZa input::placeholder {
    color: #999;
}

.blog_addBtn__26iwX {
    background: #000;
    color: white;
    padding: 10px 18px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
}

.blog_actionButtonsDeleteAdd__p8HVP {
    display: flex;
    align-items: center;
    gap: 10px;
}

.blog_deleteSelectedBtn__3Nd9S {
    cursor: pointer;
}

/* Left side */
.blog_editorBlock__52oJU {
    /* max-width: 740px; */
    margin: auto;
    padding: 0 20px;
    margin-top: 30px;
    position: relative;
    top: 0;
}

#blog_postTitle__Piy1T {
    font-style: normal;
    font-weight: 500;
    gap: 8px;
    outline: none;
    border: none;
    width: 100%;
    font-size: 36px;
    box-shadow: none;
    background: transparent;
    padding: 0;
    color: #1c1c1c;
    line-height: 48px;
}

.blog_newpageLeftRow__2-iHF input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #667085;
    padding: 14px 14px 12px;
    gap: 8px;
    background: #fff;
    border-radius: 6px;
    outline: none;
    border: none;
    width: 100%;
}

.blog_stockManage__Cfge\\+>div {
    display: flex;
    align-items: center;
    gap: 8px;
}

.blog_stockManage__Cfge\\+ input[type="checkbox"] {
    max-width: 18px;
    padding: 0;
    height: 18px;
}

.blog_stockManage__Cfge\\+ p{
    margin: 0;
}

#blog_postTitle__Piy1T[placeholder]:empty:before {
    content: attr(placeholder);
    color: #667085;
}

.blog_newpageRight__uoGBG>.blog_newPageRightRow__YAE7v.blog_bannerDropdownWrapper__aK4Jn:has(.blog_expanded__Y6\\+vO),
.blog_newpageRight__uoGBG>.blog_newPageRightRow__YAE7v.blog_bannerDropdownWrapper__aK4Jn:has(.blog_expanded__Y6\\+vO) .blog_contentDrop__TYJ6j {
    overflow: visible;
}

@media screen and (max-width: 1260px) {
    .blog_newpageContent__MW9IH {
        margin-top: 30px;
        flex-direction: column;
    }

    .blog_buttonsDesktop__Q3IKR {
        display: none;
    }

    .blog_buttonsMobile__uhFom {
        display: block;
    }

    .blog_newpageRight__uoGBG,
    .blog_newpageLeft__M3k\\+b {
        width: 100%;
        max-height: 100%
    }

    .blog_newpageRight__uoGBG .blog_newPageRightRowURL__8d49u {
        border-top: 1px solid #e6e6e6;
    }

}

@media screen and (max-width: 1024px) {
    .blog_newpageImageUpload__Lm4Ey {
        margin-top: 15px;
    }

    .blog_contentWrapper__uEnQ7 {
        margin-top: 0;
    }

}

@media screen and (max-width: 767px) {
    .blog_newPageRightRow__YAE7v .blog_newpageImageUpload__Lm4Ey {
        margin-top: 10px;
        max-width: 100%;
    }

    .blog_newpageRight__uoGBG>.blog_desktopFeatures__ncwvY {
        margin-top: 0 !important;
    }

    .blog_searchBar__qGGZa,
    .blog_leftSide__4ASAl {
        width: calc(100% - 50px);
        min-width: calc(100% - 50px)
    }
}

@media screen and (max-width: 490) {
    .blog_fileUploadCover_Img__1LyIj {
        padding-top: 0 !important;
    }
}

@media screen and (max-width: 480) {
    .blog_newPageRightRow__YAE7v .blog_newpageImageUpload__Lm4Ey {
        width: 100%;
        max-width: 100%;
    }
}

@media screen and (max-width: 390) {
    .blog_fileUploadCover_Img__1LyIj {
        padding-top: 15px;
    }
}

/* Blog list specific styles (from product CSS) */
.blog_productDatatableList__NaavO {
    padding: 30px 30px 0;
}

.blog_productHeader__hiBrz {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 10px;
}

.blog_leftSide__4ASAl {
    display: flex;
    align-items: center;
    gap: 10px;
}

.blog_productListHeight__B-NtR {
    overflow-y: hidden;
}
/* Blog category specific styles */
.blog_categoryPageSearch__9YAvu {
    position: relative;
}
.blog_categoryPageSearch__9YAvu img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
}
.blog_categoriesList__-PKHY {
    max-height: 165px;
    overflow-y: auto;
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 0;
}

.blog_categoriesList__-PKHY li {
    margin-bottom: 4px;
}

/* Featured image */
.blog_featuredImg__pb-l\\+ {
    width: 100%;
    height: 100%;
    cursor: pointer;
    border-radius: 6px;
    object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Blog/blog.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mFAAmF;IACnF,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,8CAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;;;;;;IAMI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,SAAO;IACP,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA,cAAc;AACd;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAEA;QACI,6BAA6B;IACjC;;AAEJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,wBAAwB;QACxB;IACJ;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA,iDAAiD;AACjD;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;AACA,kCAAkC;AAClC;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":[".newpageContent {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n    /* min-height: calc(100vh - 67px); */\n    min-height: 100vh;\n}\n\n.newpageRight {\n    border-left: 1px solid #e6e6e6;\n    margin-top: 0;\n    max-height: calc(100vh - 67px);\n    /* min-height: 100vh; */\n    padding: 0;\n    overflow-y: auto;\n    position: relative;\n    width: 410px;\n}\n\n.newpageLeft {\n    max-height: calc(100dvh - 100px);\n    overflow-y: auto;\n    /* margin-right: 36px; */\n    padding-right: 40px;\n    padding-left: 40px;\n    width: calc(100% - 410px);\n    padding-top: 30px;\n}\n\n.buttonsDesktop {\n    border-bottom: 1px solid #e6e6e6;\n    padding: 20px 30px;\n    display: block;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 2;\n}\n\n.buttonsMobile {\n    border-bottom: 1px solid #e6e6e6;\n    padding: 20px 30px;\n    display: none;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 2;\n}\n\n.newpageRightButtons {\n    display: inline-flex;\n    position: relative;\n    height: 44px;\n}\n\n.newpageRightButtons button {\n    font-family: 'CyGrotesk-KeyRegular';\n}\n\n.newpageRightButtons button:first-child {\n    border-radius: 6px;\n}\n\n.newpageRightButtons button:first-child {\n    border-radius: 4px;\n    background: #0a0a0a;\n}\n\n.newpageRightButtons button:first-child {\n    /* background: #0a0a0a; */\n    margin-right: 8px;\n    /* min-width: 69px; */\n    min-height: 42px;\n    position: relative;\n    justify-content: center;\n    border-radius: 6px !important;\n}\n\n.newpageRightButtons .publishButton {\n    width: 97.3px;\n}\n\n.newpageRightButtons button {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    display: flex;\n    gap: 8px;\n    /* border-radius: 6px; */\n    align-items: center;\n    padding: 10px;\n    /* border: none; */\n    /* color: #fff; */\n    cursor: pointer;\n}\n\n.primaryButton {\n    box-shadow: 0 1px 3px #0000001a;\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n}\n\n.newpageRightButtons button:first-child p {\n    font-weight: 500;\n    margin: 0;\n}\n\n.newpageRightButtons button:nth-child(2) {\n    margin-right: 8px;\n}\n\n.newpageRightButtons .draftButton {\n    width: 120px;\n}\n\n.secondaryButton {\n    background-color: #fff;\n    color: #344054;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.updatePagebtn {\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.updateDraftButton {\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.newpageMoreButtons {\n    background-color: #fff;\n    color: #344054;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n    width: 44px;\n    height: 42px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.actionDots {\n    width: 16px;\n    height: 16px;\n}\n\n.buttonsMobile .publishedButtonsList {\n    top: -90px;\n}\n\n.publishedButtonsList {\n    position: absolute;\n    top: 50px;\n    right: 0;\n    background: #fff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n    min-width: 150px;\n}\n\n.publishedButtonsList ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.publishedButtonsList li {\n    padding: 10px 15px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #344054;\n}\n\n.publishedButtonsList li:first-child {\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n}\n\n.publishedButtonsList li:last-child {\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n}\n\n.publishedButtonsList li:hover {\n    background-color: #f9fafb;\n}\n\n.publishStatus {\n    margin-top: 10px;\n    font-size: 14px;\n    color: #344054;\n    margin-bottom: 0;\n}\n\n.publishButton {\n    width: 97.3px;\n}\n\n.updatePagebtn {\n    width: 74.83px;\n}\n\n.updateDraftButton {\n    width: 116.92px;\n}\n\n.draftButton {\n    width: 120px;\n}\n\n.ringLoader {\n    width: 20px;\n    height: 20px;\n    border: 2px solid #f3f3f3;\n    border-top: 2px solid #000;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.newpageRight>.newPageRightRow {\n    border-bottom: 1px solid #e6e6e6;\n    border-top: 0;\n    overflow: hidden;\n    padding: 20px 30px;\n}\n\n.newPageRightFullUrl,\n.newPageRightTitle {\n    color: #344054;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 500;\n}\n\n.iconDropWrap {\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    margin: 0;\n}\n\n.iconDropWrap span {\n    font-weight: 500;\n    margin-right: 3px;\n    width: calc(100% - 15px);\n    display: block;\n}\n\n.newPageRight:has(.expanded) .dropdownIcon,\n.newPageRightRow:has(.expanded) .dropdownIcon {\n    transform: rotate(-180deg);\n}\n\n.dropdownIcon {\n    transition: all 0.2s linear;\n    width: 12px;\n}\n\n.expanded {\n    max-height: 1000px;\n    transition: max-height 0.8s ease-in-out 0s;\n}\n\n.collapse {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.6s ease-in-out 0s;\n}\n\n.urlInput {\n    display: block;\n    width: 100%;\n}\n\n.adressInputBlock {\n    position: relative;\n}\n\n.adressInputBlock .adressLink {\n    top: 24px;\n}\n\n.adressLink,\n.publication-Link .adressInputBlock .url-icon {\n    left: 14px;\n    position: absolute;\n    top: 1.48rem;\n    width: 17px;\n    height: 17px;\n}\n\n.adressInputBlock.urlInput>input {\n    padding-left: 40px;\n}\n\n.adressInputBlock input,\n.textExpert {\n    padding: 8px 12px;\n    gap: 8px;\n    height: 45px;\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    outline: none;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding-left: 40px;\n    font-size: 14px;\n}\n\n.textExpert {\n    resize: vertical;\n    overflow-x: hidden;\n    min-height: calc(1.2em * 5);\n    padding: 8px 12px;\n}\n\n.list-search p {\n    color: #344054;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.newpageRight>.desktopFeatures {\n    border-bottom: 1px solid #eaecf0;\n}\n\n.newpageRight>.desktopFeatures:has(.expanded) {\n    border-color: transparent;\n}\n\n.newpageRight>.newPageRight {\n    padding: 20px 30px;\n}\n\n.newPageRightRow.imageUploadBox {\n    margin-top: 10px;\n    height: 200px;\n    position: relative;\n    border: 1px solid black;\n    border-radius: 6px;\n}\n\n.newpageImageUpload {\n    background: #fff;\n    border: 1px solid #eaecf0;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n    min-height: 100%;\n    max-width: 384px;\n    position: relative;\n    z-index: 0;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.fileUploadCover_Img {\n    margin: 0 auto;\n    display: block;\n}\n\n.fileUploadBox .fileUploadCover_Img {\n    margin: 0 auto;\n    background: #f2f4f7;\n    border: 6px solid #f9fafb;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    height: 40px;\n    width: 40px;\n    padding: 5px !important;\n    margin-bottom: 5px;\n}\n\n.newpageImageUpload .featureImgMiddleContent,\n.newpageImageUpload div .newpage_CoverImg,\n.newpageImageUpload .featureImgMiddleContent,\n.newpageImageUpload div .newpage_CoverImg,\n.newpageImageUpload .featureImgMiddleContent,\n.newpageImageUpload div .newpage_CoverImg {\n    width: 100%;\n    height: 100%;\n    min-height: 100%;\n    max-width: 100%;\n}\n\n.newPageImageUploadText {\n    font-weight: 400;\n    text-align: center;\n    font-size: 14px;\n    line-height: 24px;\n    color: #475467;\n    user-select: none;\n    text-align: center;\n    padding-top: 10px;\n}\n\n.newPageImageUploadText span {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #1c1c1c;\n}\n\n.contentDrop>div.scheduleCheckbox {\n    margin-top: 9px;\n    position: relative;\n}\n\n.listSearch label {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    cursor: pointer;\n}\n\n.listSearch input[type=\"checkbox\"] {\n    font-size: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid transparent;\n    -o-appearance: none;\n    appearance: none;\n    position: relative;\n    padding: 0 0 0 0;\n    margin: 0;\n    margin-right: 9px !important;\n    box-shadow: none;\n}\n\n.listSearch input[type=\"checkbox\"]:before {\n    position: absolute;\n    left: 0;\n    top: -1px;\n    margin-right: 0;\n}\n\n.scheduleCheckbox p {\n    text-transform: unset;\n}\n\n.listSearch p {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n}\n\n.verticleDots {\n    position: relative;\n    left: 0;\n}\n\n.pageListHeight {\n    overflow-y: hidden;\n}\n\n.pageDatatableList {\n    padding: 30px 30px 0;\n}\n\n.pageHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.pageHeader .pageHeading {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.pageHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.pageHeader .leftSide {\n    display: flex;\n    gap: 20px;\n}\n\n.searchBar {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    gap: 8px;\n    min-width: 250px;\n    height: 40px;\n}\n\n.searchBar img {\n    width: 16px;\n    height: 16px;\n}\n\n.searchBar input {\n    border: none;\n    background: transparent;\n    outline: none;\n    flex: 1;\n    font-size: 14px;\n    color: #333;\n}\n\n.searchBar input::placeholder {\n    color: #999;\n}\n\n.addBtn {\n    background: #000;\n    color: white;\n    padding: 10px 18px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.actionButtonsDeleteAdd {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.deleteSelectedBtn {\n    cursor: pointer;\n}\n\n/* Left side */\n.editorBlock {\n    /* max-width: 740px; */\n    margin: auto;\n    padding: 0 20px;\n    margin-top: 30px;\n    position: relative;\n    top: 0;\n}\n\n#postTitle {\n    font-style: normal;\n    font-weight: 500;\n    gap: 8px;\n    outline: none;\n    border: none;\n    width: 100%;\n    font-size: 36px;\n    box-shadow: none;\n    background: transparent;\n    padding: 0;\n    color: #1c1c1c;\n    line-height: 48px;\n}\n\n.newpageLeftRow input {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #667085;\n    padding: 14px 14px 12px;\n    gap: 8px;\n    background: #fff;\n    border-radius: 6px;\n    outline: none;\n    border: none;\n    width: 100%;\n}\n\n.stockManage>div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.stockManage input[type=\"checkbox\"] {\n    max-width: 18px;\n    padding: 0;\n    height: 18px;\n}\n\n.stockManage p{\n    margin: 0;\n}\n\n#postTitle[placeholder]:empty:before {\n    content: attr(placeholder);\n    color: #667085;\n}\n\n.newpageRight>.newPageRightRow.bannerDropdownWrapper:has(.expanded),\n.newpageRight>.newPageRightRow.bannerDropdownWrapper:has(.expanded) .contentDrop {\n    overflow: visible;\n}\n\n@media screen and (max-width: 1260px) {\n    .newpageContent {\n        margin-top: 30px;\n        flex-direction: column;\n    }\n\n    .buttonsDesktop {\n        display: none;\n    }\n\n    .buttonsMobile {\n        display: block;\n    }\n\n    .newpageRight,\n    .newpageLeft {\n        width: 100%;\n        max-height: 100%\n    }\n\n    .newpageRight .newPageRightRowURL {\n        border-top: 1px solid #e6e6e6;\n    }\n\n}\n\n@media screen and (max-width: 1024px) {\n    .newpageImageUpload {\n        margin-top: 15px;\n    }\n\n    .contentWrapper {\n        margin-top: 0;\n    }\n\n}\n\n@media screen and (max-width: 767px) {\n    .newPageRightRow .newpageImageUpload {\n        margin-top: 10px;\n        max-width: 100%;\n    }\n\n    .newpageRight>.desktopFeatures {\n        margin-top: 0 !important;\n    }\n\n    .searchBar,\n    .leftSide {\n        width: calc(100% - 50px);\n        min-width: calc(100% - 50px)\n    }\n}\n\n@media screen and (max-width: 490) {\n    .fileUploadCover_Img {\n        padding-top: 0 !important;\n    }\n}\n\n@media screen and (max-width: 480) {\n    .newPageRightRow .newpageImageUpload {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n\n@media screen and (max-width: 390) {\n    .fileUploadCover_Img {\n        padding-top: 15px;\n    }\n}\n\n/* Blog list specific styles (from product CSS) */\n.productDatatableList {\n    padding: 30px 30px 0;\n}\n\n.productHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.leftSide {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.productListHeight {\n    overflow-y: hidden;\n}\n/* Blog category specific styles */\n.categoryPageSearch {\n    position: relative;\n}\n.categoryPageSearch img {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 12px;\n}\n.categoriesList {\n    max-height: 165px;\n    overflow-y: auto;\n    padding-left: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.categoriesList li {\n    margin-bottom: 4px;\n}\n\n/* Featured image */\n.featuredImg {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    border-radius: 6px;\n    object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newpageContent": `blog_newpageContent__MW9IH`,
	"newpageRight": `blog_newpageRight__uoGBG`,
	"newpageLeft": `blog_newpageLeft__M3k+b`,
	"buttonsDesktop": `blog_buttonsDesktop__Q3IKR`,
	"buttonsMobile": `blog_buttonsMobile__uhFom`,
	"newpageRightButtons": `blog_newpageRightButtons__Zee1P`,
	"publishButton": `blog_publishButton__0jA7O`,
	"primaryButton": `blog_primaryButton__3JSm+`,
	"draftButton": `blog_draftButton__vfQlb`,
	"secondaryButton": `blog_secondaryButton__rgdOV`,
	"updatePagebtn": `blog_updatePagebtn__m3n-I`,
	"updateDraftButton": `blog_updateDraftButton__PKfEn`,
	"newpageMoreButtons": `blog_newpageMoreButtons__Sf2bG`,
	"actionDots": `blog_actionDots__z-DHv`,
	"publishedButtonsList": `blog_publishedButtonsList__TAdQ-`,
	"publishStatus": `blog_publishStatus__JeUib`,
	"ringLoader": `blog_ringLoader__TPb8V`,
	"spin": `blog_spin__uANIX`,
	"newPageRightRow": `blog_newPageRightRow__YAE7v`,
	"newPageRightFullUrl": `blog_newPageRightFullUrl__EnNv6`,
	"newPageRightTitle": `blog_newPageRightTitle__xRfwD`,
	"iconDropWrap": `blog_iconDropWrap__i4y0w`,
	"newPageRight": `blog_newPageRight__9f+x0`,
	"expanded": `blog_expanded__Y6+vO`,
	"dropdownIcon": `blog_dropdownIcon__SAvRh`,
	"collapse": `blog_collapse__Ln0XM`,
	"urlInput": `blog_urlInput__gFrQv`,
	"adressInputBlock": `blog_adressInputBlock__gjp-G`,
	"adressLink": `blog_adressLink__xaatB`,
	"publication-Link": `blog_publication-Link__IXScO`,
	"url-icon": `blog_url-icon__0KuvW`,
	"textExpert": `blog_textExpert__qf6oP`,
	"list-search": `blog_list-search__Hu3Gn`,
	"desktopFeatures": `blog_desktopFeatures__ncwvY`,
	"imageUploadBox": `blog_imageUploadBox__Bo4q3`,
	"newpageImageUpload": `blog_newpageImageUpload__Lm4Ey`,
	"fileUploadCover_Img": `blog_fileUploadCover_Img__1LyIj`,
	"fileUploadBox": `blog_fileUploadBox__lA1Xc`,
	"featureImgMiddleContent": `blog_featureImgMiddleContent__kxJT3`,
	"newpage_CoverImg": `blog_newpage_CoverImg__VCw63`,
	"newPageImageUploadText": `blog_newPageImageUploadText__qhqPn`,
	"contentDrop": `blog_contentDrop__TYJ6j`,
	"scheduleCheckbox": `blog_scheduleCheckbox__ZUIrU`,
	"listSearch": `blog_listSearch__PbpPk`,
	"verticleDots": `blog_verticleDots__i4eyi`,
	"pageListHeight": `blog_pageListHeight__UtDrO`,
	"pageDatatableList": `blog_pageDatatableList__Vof70`,
	"pageHeader": `blog_pageHeader__wShOA`,
	"pageHeading": `blog_pageHeading__cPy+H`,
	"leftSide": `blog_leftSide__4ASAl`,
	"searchBar": `blog_searchBar__qGGZa`,
	"addBtn": `blog_addBtn__26iwX`,
	"actionButtonsDeleteAdd": `blog_actionButtonsDeleteAdd__p8HVP`,
	"deleteSelectedBtn": `blog_deleteSelectedBtn__3Nd9S`,
	"editorBlock": `blog_editorBlock__52oJU`,
	"postTitle": `blog_postTitle__Piy1T`,
	"newpageLeftRow": `blog_newpageLeftRow__2-iHF`,
	"stockManage": `blog_stockManage__Cfge+`,
	"bannerDropdownWrapper": `blog_bannerDropdownWrapper__aK4Jn`,
	"newPageRightRowURL": `blog_newPageRightRowURL__8d49u`,
	"contentWrapper": `blog_contentWrapper__uEnQ7`,
	"productDatatableList": `blog_productDatatableList__NaavO`,
	"productHeader": `blog_productHeader__hiBrz`,
	"productListHeight": `blog_productListHeight__B-NtR`,
	"categoryPageSearch": `blog_categoryPageSearch__9YAvu`,
	"categoriesList": `blog_categoriesList__-PKHY`,
	"featuredImg": `blog_featuredImg__pb-l+`
};
export default ___CSS_LOADER_EXPORT___;
